var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgList2 = function SvgList2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.332 3h12.665M8.332 10.332h12.665M8.332 17.664h12.665M3 5a2 2 0 1 0 0-4 2 2 0 0 0 0 4M3 12.331a2 2 0 1 0 0-3.999 2 2 0 0 0 0 4M3 19.664a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })));
};
export default SvgList2;